import { Controller, useFormContext } from 'react-hook-form';
import { CheckboxGroup } from '@ds';
import { ComponentProps, ReactNode } from 'react';

type ControlledCheckboxGroupProps = Omit<ComponentProps<typeof CheckboxGroup>, 'children'> & {
  name: string;
  children: ReactNode;
};

export const ControlledCheckboxGroup = ({
  name,
  value,
  onChange,
  children,
  ...props
}: ControlledCheckboxGroupProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { invalid, error } }) => (
        <CheckboxGroup
          value={value ?? field.value}
          onChange={onChange ?? field.onChange}
          isInvalid={invalid}
          errorMessage={error?.message}
          {...props}
        >
          {children}
        </CheckboxGroup>
      )}
    />
  );
};
